import React from 'react';
import PropTypes from 'prop-types';

import * as Styled from './SocialShare.styled';

/**
 * Component for social icon bar to be used in footer
 */
const SocialShare = ({ socials }) => (
  <Styled.SocialShare aria-label="social media links">
    {socials.map((social, index) => (
      <Styled.IconContainer key={index}>
        <Styled.Link href={social.url} target="_blank" aria-label={social.name}>
          <Styled.SocialIcon name={social.name} />
        </Styled.Link>
      </Styled.IconContainer>
    ))}
  </Styled.SocialShare>
);

SocialShare.propTypes = {
  /**
   * Array of objects containing social names and corresponding URLs
   */
  socials: PropTypes.arrayOf(Object).isRequired
};

export default SocialShare;
